import React from 'react'
import { withTranslation } from 'react-i18next'

import SectionHeader from 'app/components/SectionHeader'

import './styles.scss'

const Header = ({ t }) => (
  <SectionHeader title={t('Try a different activity today')} backHref className="profile-header" />
)

export default withTranslation('user')(Header)
